import { ReactNode } from "react";
import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

interface UiKitSectionProps {
  title: string;
  children: ReactNode;
}

const [, , , spaceLg, spaceXl, spaceXxl] = adminTokens.spacing;

const Section = styled.section`
  background-color: ${adminTokens.color.surface};
  border: 1px solid ${adminTokens.color.border};
  border-radius: ${adminTokens.radius.card}px;
  box-shadow: ${adminTokens.shadow.card};
  padding: ${spaceXxl}px;
  margin-bottom: ${spaceXl}px;
`;

const Heading = styled.h2`
  color: ${adminTokens.color.navy};
  font-family: ${adminTokens.typeScale.cardHeading.fontFamily};
  font-size: ${adminTokens.typeScale.cardHeading.fontSize};
  line-height: ${adminTokens.typeScale.cardHeading.lineHeight};
  margin: 0 0 ${spaceLg}px;
`;

const toHeadingId = (title: string) => `ui-kit-section-${title.toLowerCase().replace(/\s+/g, "-")}`;

export const UiKitSection = ({ title, children }: UiKitSectionProps) => (
  <Section aria-labelledby={toHeadingId(title)}>
    <Heading id={toHeadingId(title)}>{title}</Heading>
    {children}
  </Section>
);
